import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Create axios instance with credentials for cookies
const pilotApi = axios.create({
  baseURL: `${API_URL}/api/pilot`,
  withCredentials: true, // Important: allows cookies to be sent/received
  timeout: 30000
});

const pilotService = {
  // Validate a magic link token and set pilot session cookie
  validateToken: async (token) => {
    const response = await pilotApi.post('/validate', { token });
    return response.data;
  },

  // Check if user has valid pilot session
  checkPilotAccess: async () => {
    try {
      const response = await pilotApi.get('/check');
      return response.data;
    } catch (error) {
      console.error('Error checking pilot access:', error);
      return { hasPilotAccess: false };
    }
  },

  // Clear pilot session
  logout: async () => {
    const response = await pilotApi.post('/logout');
    return response.data;
  },

  // Admin: Generate a new pilot token
  generateToken: async (email, name, expiresInDays = 7) => {
    const token = localStorage.getItem('token');
    const response = await pilotApi.post('/generate',
      { email, name, expiresInDays },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // Admin: List all pilot tokens
  listTokens: async () => {
    const token = localStorage.getItem('token');
    const response = await pilotApi.get('/tokens', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Admin: Revoke a pilot token
  revokeToken: async (tokenId) => {
    const token = localStorage.getItem('token');
    const response = await pilotApi.delete(`/tokens/${tokenId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};

export default pilotService;
